import PropTypes from "prop-types";
import { ToolbarItem } from "./toolbar-item.styles.es.js";
const propTypes = {
  expand: PropTypes.bool,
  flex: PropTypes.number
};
const defaultProps = {
  expand: false,
  flex: 0
};
ToolbarItem.propTypes = propTypes;
ToolbarItem.defaultProps = defaultProps;
export {
  ToolbarItem
};
